define([
  "marionette",
  "underscore",
  "./template/topicAttributesTemplate.html",
  "./template/topicAttributeItemTemplate.html",
], function (Marionette, _, TopicAttributesTemplate, TopicAttributeItemTemplate) {
  const TopicAttributesView = {};

  TopicAttributesView.topicAttributeItemView = Marionette.ItemView.extend({
    tagName: "tr",
    events: {
      "change #attributeId": function () {
        const attributeIdSelected = parseInt(
          this.$el.find("#attributeId option:selected").val(),
          10,
        );
        const attributeName = this.$el.find("#attributeId option:selected").text();
        this.$el.find("attributeId").val(attributeIdSelected).trigger("change");
        this.trigger("change:attribute", attributeIdSelected, attributeName);
      },
      "change #localeOverride": function () {
        const localeOverride = this.getLocaleOverride();
        const selectedLanguageId = this.model.collection.selectedLanguageId;
        if (!localeOverride) {
          this.model.set("localizedAttributeValue_" + selectedLanguageId, null);
        } else {
          this.model.set("localizedAttributeValue_" + selectedLanguageId, "");
        }
      },
    },
    triggers: {
      "click #attributeDelete": "delete:attribute",
      "change #entryName": "save:attributeValue",
    },
    modelEvents: {
      "change entrySurfaceForm": "render",
      "change:attribute": "render",
    },
    template: TopicAttributeItemTemplate,
    templateHelpers: {
      haveLocalizedAttributeValue: function () {
        // This is the model, not the view
        const selectedLanguageId = this._thisObject.collection.selectedLanguageId;
        if (!selectedLanguageId) {
          return false;
        }
        const attributeName = "localizedAttributeValue_" + selectedLanguageId;
        const attributeValue = this[attributeName];
        return !_.isUndefined(attributeValue) && attributeValue !== null;
      },
    },
    enableTextbox: function (selector) {
      // Prevent the user from editing the localized value if the "localeOverride" checkbox is unchecked
      if (/#localizedAttributeValue_/i.test(selector)) {
        const value = this.model.get(selector.substring(1));
        if (_.isUndefined(value) || value === null) {
          return;
        }
      }
      this.constructor.__super__.enableTextbox.call(this, selector);
    },
    initialize: function (options) {
      const me = this;
      this.model.attributeList = options.attributeList;
      this.model.on("change", this.render, this);
      const selectedLanguageId = this.model.collection.selectedLanguageId;
      if (!options.allowEditAttributes) {
        this.textboxes = {};
      } else if (!selectedLanguageId) {
        this.textboxes = {
          "#entryName": {
            enableSelector: "#entryName",
            modelAttribute: "attributeValue",
            placeholder: "topic.attributes.attributePlaceholder",
            textArea: true,
          },
        };
      } else {
        const localizedAttributeName = "localizedAttributeValue_" + selectedLanguageId;
        const textbox = {
          enableSelector: "#" + localizedAttributeName,
          modelAttribute: localizedAttributeName,
          textArea: true,
          doNotModifyPlaceholder: true,
          placeholder: function () {
            if (me.getLocaleOverride()) {
              return "";
            }
            return _.escape(me.model.get("attributeValue"));
          },
        };
        this.textboxes = {};
        this.textboxes["#localizedAttributeValue_" + selectedLanguageId] = textbox;
      }
    },
    getLocaleOverride: function () {
      return this.$el.find("#localeOverride").prop("checked");
    },
  });

  TopicAttributesView.topicAttributesView = Marionette.CompositeView.extend({
    itemView: TopicAttributesView.topicAttributeItemView,
    itemViewContainer: "tbody",
    template: TopicAttributesTemplate,
    triggers: {
      "click #addAttribute": "add:attribute",
    },
    events: {
      "change #languages": "onChangeLanguages",
    },

    initialize: function (options) {
      this.allowDeleteAttributes = options.allowDeleteAttributes;
      this.allowEditAttributes = options.allowEditAttributes;
      this.attributeList = options.attributeList;
      this.languagesWithDefault = options.languagesWithDefault;
      this.selectedLanguage = options.selectedLanguage;
      this.collection.allowDeleteAttributes = options.allowDeleteAttributes;
      this.collection.allowEditAttributes = options.allowEditAttributes;
      this.collection.languagesWithDefault = options.languagesWithDefault;
      this.collection.selectedLanguage = options.selectedLanguage;
      this.collection.selectedLanguageId = options.selectedLanguage.get("id");
    },

    itemViewOptions: function () {
      return {
        allowDeleteAttributes: this.allowDeleteAttributes,
        allowEditAttributes: this.allowEditAttributes,
        attributeList: this.attributeList,
      };
    },

    onChangeLanguages: function () {
      const optionSelected = this.$el.find("#languages option:selected").val();
      const languageId = parseInt(optionSelected, 10);
      this.trigger("change:selectedLanguageId", languageId);
    },

    showError: function (errorMessage) {
      this.clearErrors();
      this.$el
        .find("#topicAttributeError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },

    clearErrors: function () {
      this.$el.find("#topicAttributeError").html("");
    },

    setSelectedLanguage: function (selectedLanguage) {
      this.selectedLanguage = selectedLanguage;
      this.collection.selectedLanguage = selectedLanguage;
      this.collection.selectedLanguageId = selectedLanguage.get("id");
      this.render();
    },
  });

  return TopicAttributesView;
});
